/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { getShiftData } from "../../../../api/apiCall";
import { useAuth } from "../../../../auth/auth";
import { format } from "date-fns";

export const getNoticePeriod = (noticePeriod: number) => {
    switch(noticePeriod) {
        case 0: return "Less than 24 hours";
        case 1: return "Less than 48 hours";
        case 2: return "More than 3 days";
        case 3: return "Excused (Valid reason)";
    }
}

const CancelledShifts = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any>([]);
    const [noticePeriod, setNoticePeriod] = useState<number | null>(null);

  const getWorkers = async (data: any) => {
    const response: any = await getShiftData(state.user?.token, {noticePeriod});
    setWorkers(response.data)
  }

  const handleClick = (userId: any) => {
    const url = `/pace-team/resourcing/profile?workerId=${userId}`;
    window.open(url, '_blank');
  };

  const columns: any = [
    {
      field: "workerName",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.workerId)}
          style={{cursor: "pointer"}}
        >
          {params.row.workerName}
        </div>
      ),
    },
    {
      field: "whatsAppName",
      headerName: "Team Name",
      flex: 1,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: "jobDate",
      headerName: "Job Date",
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {format(new Date(params.row.jobDate || Date.now()), 'dd/MM/yyyy')}
        </div>
      ),
    },
    {
      field: "cancellationDate",
      headerName: "Date Cancellation",
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        <div>
          {format(new Date(params.row.cancellationDate || Date.now()), 'dd/MM/yyyy')}
        </div>
      ),
    },
    {
      field: "noticePeriod",
      headerName: "Notice Period",
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => (
        getNoticePeriod(params.row.noticePeriod)
      )
    },
    {
      field: "reason",
      headerName: "Reason",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.workerId)}
          style={{
            boxShadow: 'none',
            backgroundColor: '#6c757d'
          }}
        >
          Details
        </Button>
      )
    }
  ];

  useEffect(() => {
    getWorkers({});
  }, []);

  return (
    <>
      <div className="form-content" style={{justifyContent: "flex-start", marginLeft: 85}}>
        <TextField
            select
            size="small"
            label="Tier"
            fullWidth
            value={noticePeriod}
            style={{width: 300, margin: 10}}
            onChange={(e) => setNoticePeriod(Number(e.target.value))}
        >
            <MenuItem value={0}>Less than 24 hours</MenuItem>
            <MenuItem value={1}>Less than 48 hours</MenuItem>
            <MenuItem value={2}>More than 3 days</MenuItem>
            <MenuItem value={3}>Excused (Valid reason)</MenuItem>
        </TextField>
        <Button
          variant="contained"
          onClick={getWorkers}
          style={{height: 40, margin: 10, boxShadow: 'none', width: "10%"}}>
          Filter
        </Button>
      </div>
      <Box sx={{height: "800px", width: "90%", margin: '0 auto'}} mt={3}>
        <DataGrid
          rows={workers || []}
          columns={columns}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 100,
              },
            },
          }}
          pageSizeOptions={[100]}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: '#f0f0f0',
              color: "#000",
              fontWeight: "bold",
            },
            '& .disable-columns': {
              borderRight: '1px solid #bfbfbf'
            },
            '& .border-left': {
              borderLeft: '1px solid #bfbfbf',
            },
          }}
        />
      </Box>
    </>
  );
};

export default CancelledShifts;
